export default __webpack_public_path__ + "static/media/image 15.11293c67.svg";